import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "Services", id: "services", testid: "nav-link-services" },
  { label: "Membership", id: "membership", testid: "nav-link-membership" },
  { label: "Results", id: "results", testid: "nav-link-results" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header data-testid="main-nav" className="fixed top-0 inset-x-0 z-50 bg-ink/90 backdrop-blur-md border-b border-graphite/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-baseline gap-2"
          aria-label="DARK Mobile Detail — back to top"
        >
          <span className="font-display font-semibold text-xl tracking-[0.12em] metallic-text">DARK</span>
          <span className="font-accent text-[9px] tracking-[0.3em] text-volt uppercase hidden sm:inline">Mobile Detail</span>
        </button>
        <nav className="hidden md:flex items-center gap-10" aria-label="Primary">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-accent text-xs tracking-[0.22em] uppercase text-silver/70 hover:text-ivory transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-request-service"
            onClick={() => go("request")}
            className="font-accent text-[11px] sm:text-xs tracking-[0.2em] uppercase bg-volt text-white px-4 sm:px-6 py-2.5 hover:bg-[#4A8FFF] transition-colors duration-300"
          >
            Request Service
          </button>
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-silver"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden bg-ink border-t border-graphite/70 px-5 py-2" aria-label="Mobile">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full text-left font-accent text-xs tracking-[0.25em] uppercase text-silver/80 py-4 border-b border-graphite/50 last:border-0"
            >
              {l.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
